<template>
    <div>
        <Card shadow>
            <Row :gutter="18">
                <Col span="3">
                    <label style="display: flex; align-items: center">
                        <span style="width: 120px">特征信息:</span>
                        <Input v-model="table.params.account" placeholder="特征信息" clearable></Input>
                    </label>
                </Col>
                <Col span="2">
                    <label style="display: flex; align-items: center">
                        <span style="width: 120px">特征类型:</span>
                        <Select v-model="table.params.types" placeholder="特征类型" clearable filterable>
                            <Option v-for="(item, index) in typeList" :value="item.value" :label="item.name" :key="index">
                                {{ item.name }}
                            </Option>
                        </Select>
                    </label>
                </Col>

                <Col span="2">
                    <label style="display: flex; align-items: center">
                        <span style="width: 120px">自动封号:</span>
                        <Select v-model="table.params.is_black" placeholder="自动封号" clearable filterable>
                            <Option v-for="(item, index) in statusList" :value="item.value" :label="item.name" :key="index">
                                {{ item.name }}
                            </Option>
                        </Select>
                    </label>
                </Col>
                <Col span="3">
                    <label style="display: flex; align-items: center">
                        <span style="width: 120px">限制转出:</span>
                        <Select v-model="table.params.is_put" placeholder="限制转出" clearable filterable>
                            <Option v-for="(item, index) in statusList" :value="item.value" :label="item.name" :key="index">
                                {{ item.name }}
                            </Option>
                        </Select>
                    </label>
                </Col>
                <Col span="3">
                    <label style="display: flex; align-items: center">
                        <span style="width: 170px">限制转出备注:</span>
                        <Select v-model="table.params.put_desc" placeholder="限制转出备注" clearable filterable>
                            <Option v-for="(item, index) in statusList" :value="item.value" :label="item.name" :key="index">
                                {{ item.name }}
                            </Option>
                        </Select>
                    </label>
                </Col>
                <Col span="3">
                    <label style="display: flex; align-items: center">
                        <span style="width: 170px">限制智能策略:</span>
                        <Select v-model="table.params.is_risk" placeholder="限制智能策略" clearable filterable>
                            <Option v-for="(item, index) in statusList" :value="item.value" :label="item.name" :key="index">
                                {{ item.name }}
                            </Option>
                        </Select>
                    </label>
                </Col>
                <Col span="3">
                    <label style="display: flex; align-items: center">
                        <span style="width: 120px">限制彩金:</span>
                        <Select v-model="table.params.is_give" placeholder="限制彩金" clearable filterable>
                            <Option v-for="(item, index) in statusList" :value="item.value" :label="item.name" :key="index">
                                {{ item.name }}
                            </Option>
                        </Select>
                    </label>
                </Col>
                <Col span="5">
                    <Button type="primary" @click="GetAbnotmalStock(1)" style="margin-right: 12px">查询</Button>
                    <Button type="warning" @click="OpenModal1(1)" style="margin-right: 12px">上传特征库</Button>
                    <Button type="info" @click="Refres">同步配置</Button>
                </Col>
            </Row>
        </Card>
        <Table border :columns="table.columns" :data="table.data" style="margin-top: 10px" :max-height="650" @on-selection-change="selectChange"></Table>
        <Page show-total v-show="table.data.length" style="margin-top: 10px" :current="table.params.page" :total="table.total" :page-size-opts="table.pageSizes" :page-size="table.params.page_size" show-sizer @on-page-size-change="limitchange" @on-change="pagechange"></Page>
        <Button type="warning" @click="DelAbnormalManyList()" style="margin-top: 10px; margin-right: 12px" :disabled="currentSelectItem.length == 0">批量删除</Button>
        <Button type="error" @click="DelAll()" style="margin-top: 10px">删除全部</Button>
        <Modal v-model="modal1.show" @on-cancel="CloseModal1" width="850" @on-ok="uploadAbnotmalStock">
            <p slot="header" style="color: #1c2438">
                <span>添加异常特征库</span>
            </p>
            <div>
                <Form :model="modal1.form.data" :label-width="80">
                    <FormItem label="特征类型:">
                        <RadioGroup v-model="modal1.form.data.types">
                            <Radio :label="item.value" style="margin-right: 20px" v-for="(item, index) in typeList" :key="index">{{ item.name }}</Radio>
                        </RadioGroup>
                    </FormItem>
                    <FormItem label="手动输入:">
                        <Input v-model="modal1.form.data.lines" maxlength="1199" type="textarea" placeholder="输入特征信息,多次用换行分隔,单次不超过100个" :rows="4" />
                    </FormItem>
                    <FormItem label="备注:">
                        <Input v-model="modal1.form.data.desc" maxlength="20" placeholder="备注信息，不超过20个字符" />
                    </FormItem>
                </Form>
            </div>
            <div>
                <div style="position: relative">
                    <Upload type="drag" action>
                        <div style="padding: 20px 0; width: 65%; float: left">
                            <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                            <p style="text-align: center">文件格式：【csv】的文件；</p>
                            <p style="text-align: center">文件大小：不大于1M；</p>
                        </div>
                        <div style="padding: 20px 0; width: 35%; float: left">
                            <p>上传文件示意图</p>
                            <table border="1" cellpadding="10" cellspacing="0" style="margin-left: 25%; width: 50%">
                                <tr>
                                    <th>account</th>
                                    <th>desc</th>
                                </tr>
                                <tr>
                                    <td>abcdedd</td>
                                    <td>刷子1</td>
                                </tr>
                                <tr>
                                    <td>bdessd</td>
                                    <td></td>
                                </tr>
                            </table>

                            <p style="margin-top: 10px">上传的文件内容必须带有表头,account代表特征信息,desc代表备注文本</p>
                        </div>
                    </Upload>
                    <input type="file" ref="abnormalUpload" accept=".txt, .csv" class="outputlist_upload" />
                </div>
                <Form :label-width="100">
                    <Row>
                        <span style="margin-right: 12px" @click.prevent.stop="updateType(0, 1)">
                            <Radio :disabled="modal1.form.data.types == 5" :value="modal1.form.data.is_black">自动封号</Radio>
                        </span>
                        <span style="margin-right: 12px" @click.prevent.stop="updateType(1, 1)">
                            <Radio :disabled="modal1.form.data.types == 5" :value="modal1.form.data.is_put">限制转出</Radio>
                        </span>
                        <span style="margin-right: 12px" @click.prevent.stop="updateType(2, 1)">
                            <Radio :value="modal1.form.data.put_desc">转出风险备注</Radio>
                        </span>
                        <span style="margin-right: 12px" @click.prevent.stop="updateType(3, 1)">
                            <Radio :disabled="modal1.form.data.types == 5" :value="modal1.form.data.is_risk">限制智能策略</Radio>
                        </span>
                        <span style="margin-right: 12px" @click.prevent.stop="updateType(4, 1)">
                            <Radio :disabled="modal1.form.data.types == 5" :value="modal1.form.data.is_give">彩金限制</Radio>
                        </span>
                    </Row>
                </Form>
            </div>
        </Modal>
        <Modal v-model="modal2.show" @on-cancel="CloseModal2" width="850" @on-ok="UpdateAbnotmalStock">
            <p slot="header" style="color: #1c2438">
                <span>修改异常特征库</span>
            </p>
            <div>
                <Form :model="modal2.form.data" :ref="modal2.form.ref" :label-width="80" :rules="modal2.form.rules">
                    <FormItem label="特征类型:">
                        <RadioGroup v-model="modal2.form.data.types">
                            <Radio :label="item.value" style="margin-right: 20px" v-for="(item, index) in typeList" :key="index">{{ item.name }}</Radio>
                        </RadioGroup>
                    </FormItem>
                    <FormItem label="特征信息:" prop="account">
                        <Input v-model="modal2.form.data.account" maxlength="1199" placeholder="输入特征信息" />
                    </FormItem>
                    <FormItem label="备注:">
                        <Input v-model="modal2.form.data.desc" maxlength="20" placeholder="备注信息，不超过20个字符" />
                    </FormItem>
                </Form>
            </div>
            <div>
                <Form :label-width="100">
                    <Row>
                        <span style="margin-right: 12px" @click.prevent.stop="updateType(0, 2)">
                            <Radio :disabled="modal2.form.data.types == 5" :value="modal2.form.data.is_black">自动封号</Radio>
                        </span>
                        <span style="margin-right: 12px" @click.prevent.stop="updateType(1, 2)">
                            <Radio :disabled="modal2.form.data.types == 5" :value="modal2.form.data.is_put">限制转出</Radio>
                        </span>
                        <span style="margin-right: 12px" @click.prevent.stop="updateType(2, 2)">
                            <Radio :value="modal2.form.data.put_desc">转出风险备注</Radio>
                        </span>
                        <span style="margin-right: 12px" @click.prevent.stop="updateType(3, 2)">
                            <Radio :disabled="modal2.form.data.types == 5" :value="modal2.form.data.is_risk">限制智能策略</Radio>
                        </span>
                        <span style="margin-right: 12px" @click.prevent.stop="updateType(4, 2)">
                            <Radio :disabled="modal2.form.data.types == 5" :value="modal2.form.data.is_give">彩金限制</Radio>
                        </span>
                    </Row>
                </Form>
            </div>
        </Modal>
    </div>
</template>
<script>
import { GetAbnotmalStock, BatchAbnotmalStock, UploadAbnotmalStock, UpdateAbnotmalStock, RefreshConfig, DeleteAllAbnotmalStock } from '@/api/admin/risk'
export default {
    name: 'abnormalCharacteristics',
    data() {
        return {
            currentSearch: {
                platid: 0,
                app_id: 0
            },
            currentSelectItem: [],
            statusList: [
                { value: 1, name: '是' },
                { value: 0, name: '否' }
            ],
            typeList: [
                { value: 1, name: 'ip' },
                { value: 2, name: 'Mac' },
                { value: 3, name: '手机号码' },
                { value: 4, name: '转出账户' },
                { value: 5, name: '转出姓名' }
            ],
            modal2: {
                show: false,
                form: {
                    ref: 'modal2_form',
                    data: { lines: '' },
                    rules: {
                        account: [
                            {
                                required: true,
                                trigger: 'change',
                                validator: (rule, value, callback) => {
                                    if (!value) {
                                        callback(new Error('请输入特征信息'))
                                    } else {
                                        callback()
                                    }
                                }
                            }
                        ]
                    }
                }
            },
            modal1: {
                show: false,
                form: {
                    ref: 'modal1_form',
                    data: {}
                }
            },
            table: {
                params: { types: null, account: '', put_desc: null, is_black: null, is_put: null, is_risk: null, is_give: null },
                pageSizes: [10, 20, 30, 40],
                total: 0,
                data: [],
                columns: [
                    { type: 'selection', width: 50, align: 'center', fixed: 'left' },
                    { title: '特征信息', key: 'account', width: 100, align: 'center' },
                    {
                        title: '特征类型',
                        key: 'atype',
                        minWidth: 100,
                        align: 'center',
                        render: (h, params) => h('span', this.atypeMap[params.row.types] || '')
                    },
                    {
                        title: '自动封号',
                        key: 'is_black',
                        width: 100,
                        align: 'center',
                        render: (h, params) => {
                            if (params.row.is_black == 1) {
                                return h('span', { style: 'color:green' }, '是')
                            }
                            return h('span', '否')
                        }
                    },
                    {
                        title: '限制转出',
                        key: 'is_put',
                        width: 100,
                        align: 'center',
                        render: (h, params) => {
                            if (params.row.is_put == 1) {
                                return h('span', { style: 'color:green' }, '是')
                            }
                            return h('span', '否')
                        }
                    },
                    {
                        title: '限制转出备注',
                        key: 'put_desc',
                        width: 100,
                        align: 'center',
                        render: (h, params) => {
                            if (params.row.put_desc == 1) {
                                return h('span', { style: 'color:green' }, '是')
                            }
                            return h('span', '否')
                        }
                    },
                    {
                        title: '限制智能策略',
                        key: 'is_risk',
                        width: 100,
                        align: 'center',
                        render: (h, params) => {
                            if (params.row.is_risk == 1) {
                                return h('span', { style: 'color:green' }, '是')
                            }
                            return h('span', '否')
                        }
                    },
                    {
                        title: '限制彩金',
                        key: 'is_give',
                        width: 100,
                        align: 'center',
                        render: (h, params) => {
                            if (params.row.is_give == 1) {
                                return h('span', { style: 'color:green' }, '是')
                            }
                            return h('span', '否')
                        }
                    },
                    { title: '描述', key: 'desc', minWidth: 250, align: 'center' },
                    { title: '创建时间', key: 'ctime', minWidth: 130, align: 'center' },
                    { title: '更新时间', key: 'utime', minWidth: 130, align: 'center' },
                    {
                        title: '管理',
                        key: 'options',
                        minWidth: 200,
                        fixed: 'right',
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h(
                                    'Button',
                                    {
                                        props: { type: 'primary' },
                                        style: { 'margin-right': '12px' },
                                        on: {
                                            click: () => {
                                                let item = { ...params.row }
                                                item.put_desc = !!item.put_desc
                                                item.is_black = !!item.is_black
                                                item.is_put = !!item.is_put
                                                item.is_risk = !!item.is_risk
                                                item.is_give = !!item.is_give
                                                this.modal2.form.data = item
                                                this.modal2.show = true
                                            }
                                        }
                                    },
                                    '编辑'
                                ),
                                h(
                                    'Button',
                                    {
                                        props: { type: 'error' },
                                        on: {
                                            click: () => {
                                                this.$Modal.confirm({
                                                    title: '删除特征',
                                                    content: '是否确认删除异常特征:' + params.row.id,
                                                    onOk: () => {
                                                        let item = { ids: [params.row.id] }
                                                        this.BatchAbnotmalStock(item)
                                                    }
                                                })
                                            }
                                        }
                                    },
                                    '删除'
                                )
                            ])
                        }
                    }
                ]
            },
            atypeMap: {
                1: 'ip',
                2: 'Mac',
                3: '手机号码',
                4: '转出账号',
                5: '转出姓名'
            }
        }
    },
    methods: {
        DelAll() {
            this.$Modal.confirm({
                title: '删除全部',
                content: '是否确认删除全部特征?',
                onOk: () => {
                    DeleteAllAbnotmalStock({}).then((res) => {
                        this.$Message.success('操作成功')
                        this.GetAbnotmalStock(1)
                    })
                }
            })
        },
        selectChange(selection) {
            this.currentSelectItem = [...selection]
        },
        DelAbnormalManyList() {
            if (this.currentSelectItem.length > 0) {
                let str = this.currentSelectItem.map((item) => item.id).join('、')
                this.$Modal.confirm({
                    title: '批量删除',
                    content: '是否确认删除: ' + str,
                    onOk: () => {
                        let params = { ids: this.currentSelectItem.map((item) => item.id) || [] }
                        this.BatchAbnotmalStock(params)
                    }
                })
            }
        },
        GetAbnotmalStock(num) {
            if (num) {
                this.table.params.page = 1
            }
            let params = { ...this.table.params }
            params.put_desc = params.put_desc == null ? -1 : params.put_desc
            params.is_black = params.is_black == null ? -1 : params.is_black
            params.is_put = params.is_put == null ? -1 : params.is_put
            params.is_risk = params.is_risk == null ? -1 : params.is_risk
            params.is_give = params.is_give == null ? -1 : params.is_give
            GetAbnotmalStock(params).then((res) => {
                this.table.data = res._param.data || []
                this.table.total = res._param.total
            })
        },
        limitchange(page_size) {
            this.table.params.page_size = page_size
            this.table.params.page = 1
            this.GetAbnotmalStock()
        },
        pagechange(page) {
            this.table.params.page = page
            this.GetAbnotmalStock()
        },
        BatchAbnotmalStock(params) {
            BatchAbnotmalStock(params).then((res) => {
                this.$Message.success('操作成功')
                this.GetAbnotmalStock(1)
            })
        },
        initFunc() {
            this.GetAbnotmalStock()
        },
        CloseModal1() {
            // this.$refs[this.modal1.form.ref].resetFields();
            this.modal1.show = false
        },
        CloseModal2() {
            // this.$refs[this.modal1.form.ref].resetFields();
            this.modal2.show = false
        },
        Update() {
            let params = { ...this.modal1.form.data }
            UploadAbnotmalStock(params).then((res) => {
                this.CloseModal1()
                this.GetAbnotmalStock()
            })
        },
        readExcel(e) {
            const files = e.target.files
            if (files[0].size > 1024 * 1024 * 1) {
                this.$Message.error('上传文件内容不能大于1M')
                return false
            }
            const fileReader = new FileReader()
            // let nametxt = files[0].name.substring(0,files[0].name.length-4)
            fileReader.onload = (ev) => {
                try {
                    const data = ev.target.result
                    console.log(this.modal1.form.data)
                    let { put_desc, is_risk, is_give, is_black, is_put, lines, desc, types } = this.modal1.form.data
                    const param = { lines, desc, types, put_desc: Number(put_desc), is_give: Number(is_give), is_risk: Number(is_risk), is_black: Number(is_black), is_put: Number(is_put), data, name: files[0].name }
                    UploadAbnotmalStock(param).then((res) => {
                        this.modal1.show = false
                        this.$Message.success('上传文件内容成功')
                        this.$refs.abnormalUpload['value'] = ''
                        this.GetAbnotmalStock()
                    })
                } catch (e) {
                    return false
                }
            }
            fileReader.readAsText(files[0], 'gb2312')
        },
        UpdateAbnotmalStock() {
            this.$refs[this.modal2.form.ref].validate((val) => {
                if (val) {
                    let { id, put_desc, is_risk, is_give, is_black, is_put, account, desc, types } = this.modal2.form.data
                    const param = { id, account, desc, types, put_desc: Number(put_desc), is_risk: Number(is_risk), is_give: Number(is_give), is_black: Number(is_black), is_put: Number(is_put) }
                    UpdateAbnotmalStock(param).then((res) => {
                        this.$Message.success('修改成功')
                        this.GetAbnotmalStock()
                    })
                }
            })
        },
        uploadAbnotmalStock() {
            if (this.modal1.form.data.lines == '') {
                this.modal1.show = false
                return
            }
            let { put_desc, is_risk, is_give, is_black, is_put, lines, desc, data, types } = this.modal1.form.data
            const param = { lines, desc, types, put_desc: Number(put_desc), is_risk: Number(is_risk), is_give: Number(is_give), is_black: Number(is_black), is_put: Number(is_put), data }
            UploadAbnotmalStock(param).then((res) => {
                this.modal1.show = false
                this.$Message.success('添加成功')
                this.$refs.abnormalUpload['value'] = ''
                this.GetAbnotmalStock()
            })
        },
        Refres() {
            let param = { is_all: 1, refresh_cfg: [11] }
            RefreshConfig(param).then((res) => {
                this.$Notice.success({
                    title: '操作提示',
                    desc: '成功刷新配置'
                })
                // this.getUserRiskList();
            })
        },
        // 编辑和新增
        OpenModal1() {
            this.modal1.show = true
            let data = { put_desc: false, is_black: true, is_put: false, is_risk: false, is_give: false, types: 1 }
            this.modal1.form.data = data
        },
        updateType(type, parent) {
            let from = parent == 1 ? this.modal1.form.data : this.modal2.form.data
            if (from.types == 5) {
                return
            }
            let { put_desc, is_put, is_black, is_risk, is_give } = from
            let arr = [is_black, is_put, put_desc, is_risk, is_give]
            if (arr[type] == true) {
                let count = Number(put_desc) + Number(is_put) + Number(is_black) + Number(is_risk) + Number(is_give)
                if (count < 2) return
            }
            let typeMap = {
                0: 'is_black',
                1: 'is_put',
                2: 'put_desc',
                3: 'is_risk',
                4: 'is_give'
            }
            from[typeMap[type]] = !from[typeMap[type]]
        }
    },
    watch: {
        'modal1.form.data.types': function () {
            if (this.modal1.form.data.types == 5) {
                this.modal1.form.data.put_desc = true
                this.modal1.form.data.is_risk = false
                this.modal1.form.data.is_give = false
                this.modal1.form.data.is_put = false
                this.modal1.form.data.is_black = false
            }
        },
        'modal2.form.data.types': function () {
            if (this.modal2.form.data.types == 5) {
                this.modal2.form.data.put_desc = true
                this.modal2.form.data.is_risk = false
                this.modal2.form.data.is_give = false
                this.modal2.form.data.is_put = false
                this.modal2.form.data.is_black = false
            }
        }
    },
    created() {
        this.initFunc()
        //获取报警数据类型
    },
    mounted() {
        this.$nextTick(() => {
            this.$refs.abnormalUpload.addEventListener('change', (e) => {
                //绑定监听表格导入事件
                this.readExcel(e)
            })
        })
    }
}
</script>
<style lang="less" scoped>
.btn_batch {
    margin-right: 12px;
}
.outputlist_upload {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
}
</style>
